// Service Icon List - Available icons for service selection
export const SERVICE_ICON_LIST = [
// Dashboard & Diagnostics
{
  name: 'fa-light-gauge',
  label: 'Dashboard/Diagnostics',
  category: 'Diagnostics',
  possession: 'vehicle'
}, {
  name: 'fa-regular-gauge',
  label: 'Dashboard/Diagnostics (Regular)',
  category: 'Diagnostics',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-gauge',
  label: 'Dashboard/Diagnostics (Duotone)',
  category: 'Diagnostics',
  possession: 'vehicle'
},
// General Automotive
{
  name: 'fa-light-car',
  label: 'General Auto Service',
  category: 'General',
  possession: 'vehicle'
}, {
  name: 'fa-regular-car',
  label: 'General Auto Service (Regular)',
  category: 'General',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-car',
  label: 'General Auto Service (Duotone)',
  category: 'General',
  possession: 'vehicle'
},
// Cooling System
{
  name: 'fa-light-water-temperature',
  label: 'Coolant/Temperature',
  category: 'Cooling',
  possession: 'vehicle'
}, {
  name: 'fa-regular-water-temperature',
  label: 'Coolant/Temperature (Regular)',
  category: 'Cooling',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-water-temperature',
  label: 'Coolant/Temperature (Duotone)',
  category: 'Cooling',
  possession: 'vehicle'
}, {
  name: 'fa-light-tank-water',
  label: 'Coolant Tank',
  category: 'Cooling',
  possession: 'vehicle'
}, {
  name: 'fa-regular-tank-water',
  label: 'Coolant Tank (Regular)',
  category: 'Cooling',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-tank-water',
  label: 'Coolant Tank (Duotone)',
  category: 'Cooling',
  possession: 'vehicle'
},
// Transmission
{
  name: 'fa-light-transmission',
  label: 'Transmission Service',
  category: 'Transmission',
  possession: 'vehicle'
}, {
  name: 'fa-regular-transmission',
  label: 'Transmission Service (Regular)',
  category: 'Transmission',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-transmission',
  label: 'Transmission Service (Duotone)',
  category: 'Transmission',
  possession: 'vehicle'
},
// Tires
{
  name: 'fa-light-tire',
  label: 'Tire Service',
  category: 'Tires',
  possession: 'vehicle'
}, {
  name: 'fa-regular-tire',
  label: 'Tire Service (Regular)',
  category: 'Tires',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-tire',
  label: 'Tire Service (Duotone)',
  category: 'Tires',
  possession: 'vehicle'
}, {
  name: 'fa-light-tire-flat',
  label: 'Flat Tire Repair',
  category: 'Tires',
  possession: 'vehicle'
}, {
  name: 'fa-regular-tire-flat',
  label: 'Flat Tire Repair (Regular)',
  category: 'Tires',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-tire-flat',
  label: 'Flat Tire Repair (Duotone)',
  category: 'Tires',
  possession: 'vehicle'
}, {
  name: 'fa-light-tire-pressure-warning',
  label: 'Tire Pressure',
  category: 'Tires',
  possession: 'vehicle'
}, {
  name: 'fa-regular-tire-pressure-warning',
  label: 'Tire Pressure (Regular)',
  category: 'Tires',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-tire-pressure-warning',
  label: 'Tire Pressure (Duotone)',
  category: 'Tires',
  possession: 'vehicle'
},
// Steering
{
  name: 'fa-light-steering-wheel',
  label: 'Steering Service',
  category: 'Steering',
  possession: 'vehicle'
}, {
  name: 'fa-regular-steering-wheel',
  label: 'Steering Service (Regular)',
  category: 'Steering',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-steering-wheel',
  label: 'Steering Service (Duotone)',
  category: 'Steering',
  possession: 'vehicle'
},
// Oil & Lubrication
{
  name: 'fa-light-oil-can',
  label: 'Oil Change',
  category: 'Oil',
  possession: 'vehicle'
}, {
  name: 'fa-regular-oil-can',
  label: 'Oil Change (Regular)',
  category: 'Oil',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-oil-can',
  label: 'Oil Change (Duotone)',
  category: 'Oil',
  possession: 'vehicle'
}, {
  name: 'fa-light-oil-can-drip',
  label: 'Oil Service',
  category: 'Oil',
  possession: 'vehicle'
}, {
  name: 'fa-regular-oil-can-drip',
  label: 'Oil Service (Regular)',
  category: 'Oil',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-oil-can-drip',
  label: 'Oil Service (Duotone)',
  category: 'Oil',
  possession: 'vehicle'
}, {
  name: 'fa-light-oil-temperature',
  label: 'Oil Temperature',
  category: 'Oil',
  possession: 'vehicle'
}, {
  name: 'fa-regular-oil-temperature',
  label: 'Oil Temperature (Regular)',
  category: 'Oil',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-oil-temperature',
  label: 'Oil Temperature (Duotone)',
  category: 'Oil',
  possession: 'vehicle'
},
// Repair & Maintenance
{
  name: 'fa-light-car-wrench',
  label: 'General Repair',
  category: 'Repair',
  possession: 'vehicle'
}, {
  name: 'fa-regular-car-wrench',
  label: 'General Repair (Regular)',
  category: 'Repair',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-car-wrench',
  label: 'General Repair (Duotone)',
  category: 'Repair',
  possession: 'vehicle'
},
// Warning & Diagnostics
{
  name: 'fa-light-engine-warning',
  label: 'Engine Issues',
  category: 'Warnings',
  possession: 'vehicle'
}, {
  name: 'fa-regular-engine-warning',
  label: 'Engine Issues (Regular)',
  category: 'Warnings',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-engine-warning',
  label: 'Engine Issues (Duotone)',
  category: 'Warnings',
  possession: 'vehicle'
}, {
  name: 'fa-light-brake-warning',
  label: 'Brake Service',
  category: 'Warnings',
  possession: 'vehicle'
}, {
  name: 'fa-regular-brake-warning',
  label: 'Brake Service (Regular)',
  category: 'Warnings',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-brake-warning',
  label: 'Brake Service (Duotone)',
  category: 'Warnings',
  possession: 'vehicle'
},
// Battery & Electrical
{
  name: 'fa-light-car-battery',
  label: 'Battery Service',
  category: 'Electrical',
  possession: 'vehicle'
}, {
  name: 'fa-regular-car-battery',
  label: 'Battery Service (Regular)',
  category: 'Electrical',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-car-battery',
  label: 'Battery Service (Duotone)',
  category: 'Electrical',
  possession: 'vehicle'
},
// Facility
{
  name: 'fa-light-garage-car',
  label: 'Shop/Garage Service',
  category: 'Facility',
  possession: 'vehicle'
}, {
  name: 'fa-regular-garage-car',
  label: 'Shop/Garage Service (Regular)',
  category: 'Facility',
  possession: 'vehicle'
}, {
  name: 'fa-duotone-garage-car',
  label: 'Shop/Garage Service (Duotone)',
  category: 'Facility',
  possession: 'vehicle'
},
// Additional existing icons that work well for services
{
  name: 'fa-solid-toolbox',
  label: 'General Tools',
  category: 'General',
  possession: 'none'
}, {
  name: 'fa-solid-certificate',
  label: 'Inspection/Certification',
  category: 'Certification',
  possession: 'vehicle'
}, {
  name: 'fa-regular-cog',
  label: 'Mechanical Work',
  category: 'Mechanical',
  possession: 'vehicle'
}, {
  name: 'custom-tune',
  label: 'Tune-up',
  category: 'Maintenance',
  possession: 'vehicle'
},
// Pet & Animal services (possession type animal)
{
  name: 'fa-light-paw',
  label: 'Pet Service',
  category: 'Pet & Animal',
  possession: 'animal'
}, {
  name: 'fa-regular-paw',
  label: 'Pet Service (Regular)',
  category: 'Pet & Animal',
  possession: 'animal'
}, {
  name: 'fa-duotone-paw',
  label: 'Pet Service (Duotone)',
  category: 'Pet & Animal',
  possession: 'animal'
}, {
  name: 'fa-light-dog',
  label: 'Dog Service',
  category: 'Pet & Animal',
  possession: 'animal'
}, {
  name: 'fa-regular-dog',
  label: 'Dog Service (Regular)',
  category: 'Pet & Animal',
  possession: 'animal'
}, {
  name: 'fa-duotone-dog',
  label: 'Dog Service (Duotone)',
  category: 'Pet & Animal',
  possession: 'animal'
}, {
  name: 'fa-light-cat',
  label: 'Cat Service',
  category: 'Pet & Animal',
  possession: 'animal'
}, {
  name: 'fa-regular-cat',
  label: 'Cat Service (Regular)',
  category: 'Pet & Animal',
  possession: 'animal'
}, {
  name: 'fa-duotone-cat',
  label: 'Cat Service (Duotone)',
  category: 'Pet & Animal',
  possession: 'animal'
}, {
  name: 'fa-light-cut',
  label: 'Grooming',
  category: 'Pet & Animal',
  possession: 'animal'
}, {
  name: 'fa-regular-cut',
  label: 'Grooming (Regular)',
  category: 'Pet & Animal',
  possession: 'animal'
}, {
  name: 'fa-duotone-cut',
  label: 'Grooming (Duotone)',
  category: 'Pet & Animal',
  possession: 'animal'
}, {
  name: 'fa-light-bath',
  label: 'Bathing/Wash',
  category: 'Pet & Animal',
  possession: 'animal'
}, {
  name: 'fa-regular-bath',
  label: 'Bathing/Wash (Regular)',
  category: 'Pet & Animal',
  possession: 'animal'
}, {
  name: 'fa-duotone-bath',
  label: 'Bathing/Wash (Duotone)',
  category: 'Pet & Animal',
  possession: 'animal'
},
// Real Estate services (possession type real_estate)
{
  name: 'fa-light-house',
  label: 'Property/Home',
  category: 'Real Estate',
  possession: 'real_estate'
}, {
  name: 'fa-regular-house',
  label: 'Property/Home (Regular)',
  category: 'Real Estate',
  possession: 'real_estate'
}, {
  name: 'fa-duotone-house',
  label: 'Property/Home (Duotone)',
  category: 'Real Estate',
  possession: 'real_estate'
}, {
  name: 'fa-light-key',
  label: 'Key Handover',
  category: 'Real Estate',
  possession: 'real_estate'
}, {
  name: 'fa-regular-key',
  label: 'Key Handover (Regular)',
  category: 'Real Estate',
  possession: 'real_estate'
}, {
  name: 'fa-duotone-key',
  label: 'Key Handover (Duotone)',
  category: 'Real Estate',
  possession: 'real_estate'
}, {
  name: 'fa-light-door-open',
  label: 'Showing/Open House',
  category: 'Real Estate',
  possession: 'real_estate'
}, {
  name: 'fa-regular-door-open',
  label: 'Showing/Open House (Regular)',
  category: 'Real Estate',
  possession: 'real_estate'
}, {
  name: 'fa-duotone-door-open',
  label: 'Showing/Open House (Duotone)',
  category: 'Real Estate',
  possession: 'real_estate'
}, {
  name: 'fa-light-sign',
  label: 'Listing Sign',
  category: 'Real Estate',
  possession: 'real_estate'
}, {
  name: 'fa-regular-sign',
  label: 'Listing Sign (Regular)',
  category: 'Real Estate',
  possession: 'real_estate'
}, {
  name: 'fa-duotone-sign',
  label: 'Listing Sign (Duotone)',
  category: 'Real Estate',
  possession: 'real_estate'
},
// General / non-possession services (possession type none)
{
  name: 'fa-light-calendar',
  label: 'Appointment',
  category: 'General Service',
  possession: 'none'
}, {
  name: 'fa-regular-calendar',
  label: 'Appointment (Regular)',
  category: 'General Service',
  possession: 'none'
}, {
  name: 'fa-duotone-calendar',
  label: 'Appointment (Duotone)',
  category: 'General Service',
  possession: 'none'
}, {
  name: 'fa-light-clock',
  label: 'Timed Service',
  category: 'General Service',
  possession: 'none'
}, {
  name: 'fa-regular-clock',
  label: 'Timed Service (Regular)',
  category: 'General Service',
  possession: 'none'
}, {
  name: 'fa-duotone-clock',
  label: 'Timed Service (Duotone)',
  category: 'General Service',
  possession: 'none'
}, {
  name: 'fa-light-check',
  label: 'Completed Service',
  category: 'General Service',
  possession: 'none'
}, {
  name: 'fa-regular-check',
  label: 'Completed Service (Regular)',
  category: 'General Service',
  possession: 'none'
}, {
  name: 'fa-duotone-check',
  label: 'Completed Service (Duotone)',
  category: 'General Service',
  possession: 'none'
}, {
  name: 'fa-light-toolbox',
  label: 'Tool Kit',
  category: 'General Service',
  possession: 'none'
}, {
  name: 'fa-regular-toolbox',
  label: 'Tool Kit (Regular)',
  category: 'General Service',
  possession: 'none'
}, {
  name: 'fa-duotone-toolbox',
  label: 'Tool Kit (Duotone)',
  category: 'General Service',
  possession: 'none'
}];

// Default icon for services without an icon
export const DEFAULT_SERVICE_ICON = 'fa-light-car-wrench';

// Possession types the icon library is grouped by. Keys mirror the backend's canonical
// `possession_model` enum (vehicle | animal | real_estate | none); 'all' is a picker-only
// pseudo-option so the pickers can default to showing everything.
export const SERVICE_ICON_POSSESSIONS = [{
  id: 'all',
  label: 'All'
}, {
  id: 'vehicle',
  label: 'Automotive'
}, {
  id: 'animal',
  label: 'Pet & Animal'
}, {
  id: 'real_estate',
  label: 'Real Estate'
}, {
  id: 'none',
  label: 'General'
}];

// Get icon by name
export const getServiceIcon = iconName => {
  return SERVICE_ICON_LIST.find(icon => icon.name === iconName) || {
    name: DEFAULT_SERVICE_ICON,
    label: 'General Service',
    category: 'General',
    possession: 'vehicle'
  };
};

// Group icons by category
export const getServiceIconsByCategory = () => {
  return SERVICE_ICON_LIST.reduce((acc, icon) => {
    if (!acc[icon.category]) {
      acc[icon.category] = [];
    }
    acc[icon.category].push(icon);
    return acc;
  }, {});
};

// Group icons by possession type (vehicle | animal | real_estate | none)
export const getServiceIconsByPossession = () => {
  return SERVICE_ICON_LIST.reduce((acc, icon) => {
    if (!acc[icon.possession]) {
      acc[icon.possession] = [];
    }
    acc[icon.possession].push(icon);
    return acc;
  }, {});
};